import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import ReactQuill from "react-quill";

export const FeedbackWrapper = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  padding-left: 3rem;
  
`;

export const FeedbackForm = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: left;
  padding-left: 3rem;
  padding-right: 3rem;
  width: 100%;
  height: 100%;
  gap: 1rem;

  @media (min-width: 400px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media (min-width: 600px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media (min-width: 900px) {
    padding-left: 3rem;
    padding-right: 3rem;
  }
`;

export const TextFieldWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 95%;
  margin: 1rem
`;
export const ButtonsWrapper = styled('div')`
  display: flex;
  // flex-direction: column;
  // width: 70%;
  margin: 1rem
`;

export const CustomQuillEditor = styled(ReactQuill)`
.ql-container {
    min-height: 150px !important
  }
`;

export const FormHelperTextP = styled.p`
color: #EB0014;
font-family: Roboto-Regular;
font-weight: 700;
font-size: 0.75rem;
line-height: 1.5;
letter-spacing: 0;
text-align: left;
margin-top: 3px;
margin-right: 14px;
margin-bottom: 0;
margin-left: 14px;`;